import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from "react-data-table-component";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import Cargando from "../../components/cargando";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import SinPermisos from "./../../components/sinpermisos";
import Nav from "react-bootstrap/Nav";

const url = "https://api.dacapo.com.ve/public/retiros";
const urleditar = "https://api.dacapo.com.ve/public/retirosedit";

const Retiros = () => {
  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);

  //////////////Iniciando Status data//////////////////////////
  const [data, setData] = useState([]);
  const [pending, setPending] = useState(true);
  const [modalEditar, setModalEditar] = useState(false);
  const [selectedRetiro, setSelectedRetiro] = useState({
    id: "",
    status: "",
  });

  const abrirModalEditar = (row) => {
    setSelectedRetiro(row);
    setModalEditar(true);
  };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setSelectedRetiro((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const peticionPut = async () => {
    await axios
      .put(url + "/" + selectedRetiro.id, selectedRetiro)
      .then((response) => {
        peticionGet();
        setModalEditar(false);
      })
      .catch((err) => {
        console.log(err);
        setModalEditar(false);
      });
  };

  const peticionGet = async () => {
    await axios.get(url).then((response) => {
      setData(response.data);
      setFiltroBuscar(response.data);
      setPending(false);
    });
  };

  useEffect(() => {
    peticionGet();
  }, []);

  const columns = [
    {
      name: "Accion",
      button: true,
      cell: (row) => (
        <Nav>
          <button
            onClick={() => abrirModalEditar(row)}
            className="btn btn-default"
          >
            <FaIcons.FaRegEdit />
          </button>
        </Nav>
      ),
    },
    {
      name: "Id",
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: "Nombre",
      selector: (row) => row.nombreprofesor,
    },
    {
      name: "Cantidad",
      selector: (row) => row.cantidad,
    },
    {
      name: "Banco",
      selector: (row) => row.banco,
    },
    {
      name: "Cuenta",
      selector: (row) => row.cuenta,
    },
    {
      name: "Cédula",
      selector: (row) => row.cedula,
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },
  ];

  /////////////Buscar datos//////////////////////////////////
  const [buscar, setBuscar] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);

  useEffect(() => {
    const result = data.filter((resultdata) => {
      if (resultdata.nombreprofesor.toLowerCase().match(buscar.toLowerCase())) {
        return resultdata;
      }
    });
    setFiltroBuscar(result);
  }, [buscar, data]);

  /////////////////////////////////////////////////////////////////
  if (users.rol !== undefined) {
    if (users.rol === "admin") {
      return (
        <div>
          <div className="Categorias">
            <Sidebar>
              <Card>
                <Card.Header className="bg-dark text-white" as="h3">
                  <div className="row">
                    <div className="col-md-2">Retiros</div>
                    <div className="col-md-10 text-left"></div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Card.Title>Retiros registrados</Card.Title>
                  <p>Retiros registrados en el sistema.</p>
                  <DataTable
                    columns={columns}
                    data={filtrobuscar}
                    noDataComponent="No hay elementos a mostrar"
                    progressPending={pending}
                    progressComponent={<Cargando />}
                    pagination
                    subHeader
                    subHeaderComponent={
                      <input
                        type="text"
                        placeholder="Buscar"
                        className="w-25 form-control"
                        value={buscar}
                        onChange={(e) => setBuscar(e.target.value)}
                      />
                    }
                  />

                  <Modal isOpen={modalEditar}>
                    <ModalHeader>
                      <div>
                        <h4>Editar Estado del Retiro</h4>
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <div className="form-group">
                        <label>Estado</label>
                        <select
                          className="form-control"
                          name="status"
                          value={selectedRetiro.status}
                          onChange={handleStatusChange}
                        >
                          <option value="Pendiente">Pendiente</option>
                          <option value="Procesado">Procesado</option>
                          <option value="En Revisión">En Revisión</option>
                        </select>
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className="btn btn-dark"
                        onClick={() => setModalEditar(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={() => peticionPut()}
                      >
                        Actualizar
                      </button>
                    </ModalFooter>
                  </Modal>
                </Card.Body>
              </Card>
            </Sidebar>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  } else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Retiros;